export default __webpack_public_path__ + "static/media/635.0c7fb584.jpg";